import { render, staticRenderFns } from "./TermGradesMissing.vue?vue&type=template&id=3ba3c106"
import script from "./TermGradesMissing.vue?vue&type=script&lang=js"
export * from "./TermGradesMissing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports